import { camelCase } from 'camel-case';
import type { CamelCase } from 'type-fest';
import { type TrackEventProperties, useAnalytics } from '../context';
import { DashboardEventNames } from '../types';

type DashboardEventPayload = Pick<
  TrackEventProperties,
  | 'dashboardTab'
  | 'dashboardDownloadCsv'
  | 'dashboardRangeFilter'
  | 'dashboardShortSessions'
  | 'dashboardInternalSessions'
  | 'dashboardWorkspaceFilter'
  | 'dashboardSection'
  | 'dashboardTableTab'
>;
type EventName = keyof typeof DashboardEventNames;
type FunctionName =
  `track${Capitalize<CamelCase<keyof typeof DashboardEventNames>>}`;
const functionNameEntries = Object.keys(DashboardEventNames).map(
  (eventName) => [
    eventName as EventName,
    `track${eventName[0].toUpperCase()}${camelCase(eventName.slice(1))}` as FunctionName,
  ]
);

export const useDashboardAnalytics = (location = 'analytics_page') => {
  const { trackEvent } = useAnalytics();

  return Object.fromEntries(
    functionNameEntries.map(([eventName, functionName]) => [
      functionName,
      (payload?: Partial<DashboardEventPayload>) => {
        trackEvent(DashboardEventNames[eventName], {
          ...payload,
          location,
        });
      },
    ])
  ) as {
    [K in FunctionName]: (payload: DashboardEventPayload) => void;
  };
};
